export default __webpack_public_path__ + "static/media/bg_TL_BR_d.813ae9ad.png";